// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.buyer-phone-details[data-v-61ecc780] {\n  display: block;\n  width: 100%;\n  background-color: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
